import { Box, Group, Mark, Modal, Stack, Text } from "@mantine/core"
import { Button, Loader } from "@tfg/ui"
import { useCallback, useMemo } from "react"

import { IngestionSettings } from "~/pages/Admin/Ingestion/ProductImport/components/IngestionSettings"
import { useProductImportContext } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportContext"
import { useAuth } from "~/store/auth-context"

type Props = {
  isBlankIngestion: boolean
  opened: boolean
  productsVerifiedCount: number
  ingestionId: string
  isImportingProducts: boolean
  isImportingBlankProducts: boolean
  userEmail?: string
  close: () => void
  productsImport: (params: { data: { ingestionId: string } }) => void
  importBlankProducts: (params: { data: { ingestionId: string } }) => void
}

export function ProductImportModal({
  isBlankIngestion,
  opened,
  productsVerifiedCount,
  ingestionId,
  isImportingProducts,
  isImportingBlankProducts,
  userEmail,
  close,
  productsImport,
  importBlankProducts,
}: Props) {
  const { user } = useAuth()

  const { ingestionSettings } = useProductImportContext()

  const handleProductUpload = useCallback(() => {
    if (isBlankIngestion) {
      importBlankProducts({ data: { ingestionId } })
    } else {
      productsImport({ data: { ingestionId } })
    }
  }, [isBlankIngestion, importBlankProducts, productsImport, ingestionId])

  const isImporting = useMemo(() => {
    return isImportingProducts || isImportingBlankProducts
  }, [isImportingProducts, isImportingBlankProducts])

  return (
    <>
      <Modal opened={opened} onClose={close} title="Are you sure?">
        <Stack>
          {ingestionSettings ? (
            <>
              <Text>
                You are about to upload
                <Mark fw="bold">{` ${productsVerifiedCount} `}</Mark>
                products for
                <Mark fw="bold">{` ${user?.organization?.slug} `}</Mark>
                with the following configurations
              </Text>
              <IngestionSettings
                ingestionSettings={ingestionSettings}
                isBlankIngestion={isBlankIngestion}
                mode="import"
                owner={userEmail ?? ""}
              />
              <Box>
                <Button
                  fullWidth={true}
                  onClick={handleProductUpload}
                  loading={isImporting}
                >
                  Upload Products 🚀
                </Button>
              </Box>
            </>
          ) : (
            <Group justify="center">
              <Loader />
            </Group>
          )}
        </Stack>
      </Modal>
    </>
  )
}
